import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { PershingCoreModule } from '@pershing/pershing-core';
import { PershingCommonModule, PershingModalService } from '@pershing/pershing-common';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { QuoteToggleService } from './services/quotetoggle.service';
import { QuoteToggleComponent } from './components/quotetoggle/quotetoggle.component';
import { ExchangeAgreementModule } from '@pershing/exchange-agreement';

export const COMPONENTS: any[] = [
    QuoteToggleComponent
];

@NgModule({
    imports: [
        PershingCoreModule,
        PershingCommonModule,
        ReactiveFormsModule,
        HttpClientModule,
        FormsModule,
        MatIconModule,
        MatDialogModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatSelectModule,
        MatOptionModule,
        MatProgressBarModule,
        MatCardModule,
        MatExpansionModule,
        MatDividerModule,
        MatMenuModule,
        MatInputModule,
        MatButtonModule,
        MatGridListModule,
        MatButtonToggleModule,
        MatTableModule,
        MatSlideToggleModule,
        ExchangeAgreementModule
    ],
    declarations: [
        ...COMPONENTS
    ],
    exports: [
        ...COMPONENTS
    ],
    providers: [QuoteToggleService, PershingModalService, DatePipe],
    entryComponents: []
})
export class QuoteToggleModule { }
